// extracted by mini-css-extract-plugin
export default {"container":"Tile_container__uF5Zj","tileButton":"Tile_tileButton__1SQwd","BLUE":"Tile_BLUE__VdZvH","RED":"Tile_RED__GSrrB"};